import React from 'react';
import PropTypes from 'prop-types';

/**
 * SwitchKyujitsuHyoji
 */
class SwitchKyujitsuHyoji extends React.Component {

  render() {
    const actions = this.props.actions;
    const dayFlg = this.props.data.dayFlg;

    let dayVal = 1;
    let defaultChecked = '';
    if (dayFlg == 1) {
      dayVal = 0;
      defaultChecked = 'checked';
    }

    return (
      <div>
        <div className="ctrl_form_title controlForm__title--state_enable controlForm__text--state_enable"><p>平日・休日表示</p></div>
        <div className="toggleswitch">
          <input type="checkbox" name="ToggleSwitch_day" id="on_day"
            defaultValue={0} checked={defaultChecked}
            onClick={() => actions.changeDay(dayVal)}
            readOnly />
          <label htmlFor="on_day" className={dayFlg == 1 ? 'switch-on' : 'switch-off'}>
            {dayFlg == 1 ? 'ON' : 'OFF'}
          </label>
          <p id="hidden_dayFlg" hidden>{this.props.data.dayFlg}</p>
        </div>
        <br />
      </div>
    );
  }
}

SwitchKyujitsuHyoji.propTypes = {
  actions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired
};

export default SwitchKyujitsuHyoji;
